<div class="w-full max-w-3xl flex flex-col mr-10 gap-4 flex-auto px-8 pt-9 pb-12">
	<div class="flex flex-col">

		<a class="inline-flex items-center leading-6 cursor-pointer text-accent"
			[routerLink]="['/apps/sites']">
			<span class="inline-flex items-center">
				<mat-icon class="icon-size-5 text-current"
					[svgIcon]="'heroicons_solid:arrow-sm-left'"></mat-icon>
					<span class="ml-1.5 font-medium leading-5">back</span>
			</span>
		</a>

		<span class="flex gap-2 flex-wrap mt-4 text-3xl tracking-tight leading-none">
			Register a new site
		</span>
	</div>

	<form *ngIf="newSiteForm" [formGroup]="newSiteForm">

		<div class="flex flex-col gap-4 mt-8">

			<mat-form-field class="w-full">
				<mat-label>Site name</mat-label>
				<input matInput formControlName="siteName" [required]="true"/>
				<mat-error *ngIf="newSiteForm.get('siteName').hasError('required')">
					Site name is required
				</mat-error>
			</mat-form-field>

			<mat-form-field class="w-full">
				<mat-label>Country</mat-label>
				<mat-select formControlName="countryId" [required]="true">
					<mat-option *ngFor="let country of countries" [value]="country.id">
						{{ country.countryName }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="newSiteForm.get('countryId').hasError('required')">
					Country is required
				</mat-error>
			</mat-form-field>

			<mat-form-field class="w-full">
				<mat-label>ERP site name (optional)</mat-label>
				<input matInput formControlName="erpSiteName"/>
				<mat-hint>Name used to match this site in the ERP integration</mat-hint>
			</mat-form-field>

			<mat-form-field class="w-full">
				<mat-label>Geotech calculation mode</mat-label>
				<mat-select formControlName="geotechCalculationMode">
					<mat-option [value]="'STANDARD'">Standard</mat-option>
					<mat-option [value]="'MSG'">MSG</mat-option>
					<mat-option [value]="'BARTON'">Barton</mat-option>
				</mat-select>
			</mat-form-field>

		</div>

		<div class="flex justify-end mt-6">
			<button mat-flat-button [color]="'primary'" [disabled]="saving" (click)="sendForm()">
				<mat-progress-spinner *ngIf="saving" class="mr-2" [diameter]="20" [mode]="'indeterminate'">
				</mat-progress-spinner>
				{{ saving ? 'Saving...' : 'Save' }}
			</button>

		</div>

	</form>

</div>
